import React from 'react';
import {observer} from 'mobx-react';
import {Modal, ModalButtons} from 'components/modals';
import {DragAndDrop} from 'components';

const DraggableFieldContent = observer(({model}) => {
  return (
    <div>{model.name}</div>
  );
});

const ReorderGroupsModal = observer(({uiState}) => {
  return (
    <Modal
      isOpen={uiState.reorderGroupsModalOpen}
      onHide={() => uiState.closeReorderGroupsModal()}
      size='md'
      title={'company_settings.custom_fields.Reorder Groups'}>
      <DragAndDrop
        models={uiState.reorderingGroups}
        component={DraggableFieldContent}/>
      <ModalButtons onSave={() => uiState.saveGroupOrders()} onCancel={() => uiState.closeReorderGroupsModal()}/>
    </Modal>
  );
});

export default ReorderGroupsModal;
